/**
 * One helper for the per-ask events so `ask`, `completed_count` and `total` reach every call site. A
 * discriminator missing from one path is invisible in Amplitude: that path just drops out of any segment
 * built on it.
 */
import type { SetupStepId } from "~vue/ProfileSetup/types";
import type AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";

export interface AskProgress {
    completedCount: number;
    total: number;
}

export function logAskEvent(event: AmplitudeEventNames, ask: SetupStepId, { completedCount, total }: AskProgress): void {
    void logUserInteraction(event, { ask, completed_count: completedCount, total });
}
